import { SnackbarTypes } from './snackbar.types';

const INITIAL_STATE = {
  isOpen: false,
  message: '',
};

const snackbarReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SnackbarTypes.OPEN_SNACKBAR:
      return { ...state, isOpen: true, message: action.payload };
    case SnackbarTypes.CLOSE_SNACKBAR:
      return { ...state, isOpen: false };
    default:
      return state;
  }
};

export default snackbarReducer;
